import { ChainConfig } from "@physiofit-digital/physiofit_types";
import { doc, onSnapshot } from "firebase/firestore";
import { useEffect } from "react";
import { getChainId } from "../../../core/store/chainSlice";
import { useMainStore } from "../../../core/store/mainStore";
import { db } from "../../../firebaseConfig";

export const useHandleGetChainConfig = () => {
  const chainId = useMainStore(getChainId);
  const setChainConfig = useMainStore((state) => state.setChainConfig);
  useEffect(() => {
    if (!chainId) return;
    const sub = onSnapshot(
      doc(db, `practiceChains/${chainId}/chainDocuments/chainConfig`),
      (docSnap) => {
        const data = docSnap.data() as ChainConfig | undefined;
        // The first snapshot for a document we have never read is a cache miss, and treating that as "no
        // appointment configuration" would decide the entry step before the server has answered (PF-5480).
        if (!data && docSnap.metadata.fromCache) return;
        // A document that genuinely does not exist means the chain has no appointment configuration — a
        // loaded state with zero bookable practices, not "still loading". Left undefined, the appointment
        // screens would wait forever.
        setChainConfig(data ?? { chainId });
      },
      (error) => {
        console.error("Error fetching chain config:", error);
        setChainConfig({ chainId });
      },
    );

    return () => sub();
  }, [chainId, setChainConfig]);
};
